import { ReveiwListConfigValue, SummaryCardServiceProps } from '@common/review';

import { ReviewSummaryService } from '../services/ReviewSummaryService';

interface Props {
  Component: (props: ReveiwListConfigValue & SummaryCardServiceProps) => JSX.Element;
}
export function ReviewSummaryContainer({ Component }: Props) {
  const service = ReviewSummaryService();

  if (service.isHide) {
    return null;
  }
  return <Component {...service} />;
}
